const getLocaleFormat = (value, locale) => {
    if (!value) return undefined;
    const currencyLocale = Intl.NumberFormat(locale);
    return currencyLocale.format(value);
};

// Polyfill for Promise.allSettled to work will all browsers
function allSettled(promises) {
    const wrappedPromises = promises.map((p) =>
        Promise.resolve(p).then(
            (val) => ({ status: 'fulfilled', value: val }),
            (err) => ({ status: 'rejected', reason: err })
        )
    );
    return Promise.all(wrappedPromises);
}

export { getLocaleFormat, allSettled };
